import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import AuthTenantLoader from '../../../../pages/loaders/AuthTenantLoader';
import AuthTenantPageError from '../../../../pages/error/AuthTenantPageError';
import { ADMIN_RETRIEVE_TENANT_MODULE_EMPLOYEES_API } from '../../../../api/api_data';
import { fail_retrieve_tenant_profiles_list, loading_retrieve_tenant_profiles_list, reset_retrieve_tenant_profiles_list, success_retrieve_tenant_profiles_list } from '../../../../reducers/auth_tenant/retrieve_tenant_profiles_list_Slice';
import { RETRIVE_TENANT_PROFILES_LIST_ERROR_MSG, RETRIVE_TENANT_PROFILES_LIST_SUCCESS_MSG } from '../../../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { messageToast } from '../../../../utils/Utils';
import { tenant_auth_actions_helper } from '../../../../actions/actions_helper';
import * as app_consts from "../../../../utils/app_consts";
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, DataTableHead, DataTableItem, DataTableRow, Icon } from '../../../Component';
import AuthTenantNoData from '../../../../pages/error/AuthTenantNoData';
import AdminAddEmployeeToModule from './AdminAddEmployeeToModule';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { Badge } from 'reactstrap';

const AdminViewTenantPromotionsEmployeesModal = ({ tenant_info, user_info, successFunction, data }) => {

  const [page_data, setPageData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const [sent_data, setSentData] = useState(data);
  const [sm, updateSm] = useState(false);
  const [add_employee_to_module_modal, setOpenAddEmployeeToModuleModal] = useState(false);

  useEffect(() => {
    setError("");
    retrieve_data(data?.tenant?.id, data?.tenant_module?.module_name);
    setSentData(data);
  }, []);

  const retrieve_data = (id, module_name) => {
    setError("");
    // Retreive Employees
    dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_profiles_list, success_retrieve_tenant_profiles_list, fail_retrieve_tenant_profiles_list, RETRIVE_TENANT_PROFILES_LIST_ERROR_MSG, RETRIVE_TENANT_PROFILES_LIST_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${ADMIN_RETRIEVE_TENANT_MODULE_EMPLOYEES_API}/${id}/${module_name}`));
  };

  // Listener
  const retrieve_tenant_profiles_list_listener = useSelector((state) => state.retrieve_tenant_profiles_list.retrieve_tenant_profiles_list);

  useEffect(() => {
    if (retrieve_tenant_profiles_list_listener.status !== app_consts.IDLE)
    {
      if (retrieve_tenant_profiles_list_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_tenant_profiles_list_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_tenant_profiles_list_listener.message);
          messageToast(retrieve_tenant_profiles_list_listener.message, app_consts.FAIL);
        } else if (retrieve_tenant_profiles_list_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_tenant_profiles_list_listener.data);
          setLoading(false);
        }
        dispatch(reset_retrieve_tenant_profiles_list());
      }
    }
  }, [retrieve_tenant_profiles_list_listener]);

  const open_add_employee_to_module_modal = () => {
    setOpenAddEmployeeToModuleModal(true);
  };

  const close_add_employee_to_module_modal = () => {
    setOpenAddEmployeeToModuleModal(false);
  };

  const add_employee_to_module_modal_successFunction = () => {
    retrieve_data(sent_data?.tenant?.id, sent_data?.tenant_module?.module_name);
  };


  return (
    <>
      {
        loading ?
          <>
            <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Module Employees..." />
          </>
          :
          <>
            {
              error ?
                <>
                  <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
                </>
                :
                <>
                  <BlockHead size="sm">
                    <BlockBetween>
                      <BlockHeadContent>
                        <BlockTitle page>Employees</BlockTitle>
                        <BlockDes className="text-soft">
                          <p>{!(loading || error) && `Employees ${page_data?.length}`}</p>
                        </BlockDes>
                        {!(loading) && (
                          <div className="mt-2">
                            <Link
                              onClick={(e) => {
                                e.preventDefault();
                                retrieve_data(sent_data?.tenant?.id, sent_data?.tenant_module?.module_name);
                              }}
                            >
                              <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                                <span>Refresh List</span>
                              </Button>
                            </Link>
                          </div>
                        )}
                      </BlockHeadContent>
                      {!(loading || error) && (
                        <BlockHeadContent>
                          <div className="toggle-wrap nk-block-tools-toggle">
                            <a
                              href="#more"
                              className="btn btn-icon btn-trigger toggle-expand me-n1"
                              onClick={(ev) => {
                                ev.preventDefault();
                                updateSm(!sm);
                              }}
                            >
                              <Icon name="more-v"></Icon>
                            </a>
                            <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                              <ul className="nk-block-tools g-3">
                                {(user_info?.roles?.includes(app_consts.ADD_EMPLOYEE_PROFILE) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (
                                  <li className="nk-block-tools-opt">
                                    <Button
                                      className="toggle d-none d-md-inline-flex"
                                      color="primary"
                                      onClick={open_add_employee_to_module_modal}
                                    >
                                      <Icon name="plus"></Icon>
                                      <span>Add Employee to Module</span>
                                    </Button>
                                  </li>
                                )}
                              </ul>
                            </div>
                          </div>
                        </BlockHeadContent>
                      )}
                    </BlockBetween>
                  </BlockHead>
                  {
                    page_data && page_data?.length > 0 ?
                      <>
                        <Block>
                          <div className="nk-tb-list is-separate is-medium mb-3">
                            <DataTableHead className="nk-tb-item">
                              <DataTableRow>
                                <span className="sub-text">Username</span>
                              </DataTableRow>
                              <DataTableRow size="mb">
                                <span className="sub-text">Department</span>
                              </DataTableRow>
                              <DataTableRow size="md">
                                <span className="sub-text">Position</span>
                              </DataTableRow>
                              <DataTableRow size="lg">
                                <span className="sub-text">Date Created</span>
                              </DataTableRow>
                              <DataTableRow size="lg">
                                <span className="sub-text">Last Login</span>
                              </DataTableRow>
                              <DataTableRow size="md">
                                <span className="sub-text">Status</span>
                              </DataTableRow>
                              <DataTableRow size="md">
                                <span className="sub-text">Action</span>
                              </DataTableRow>
                            </DataTableHead>
                            {/*Head*/}
                            {page_data?.length > 0
                              ? page_data?.map((item) => (
                                <DataTableItem key={item.id}>
                                  <DataTableRow>
                                    <Link to={`#`}>
                                      <div className="user-card">
                                        <div className="user-info">
                                          <span className="tb-lead">
                                            {item?.user?.first_name ? `${item?.user?.first_name} ${item?.user?.last_name}` : "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                          </span>
                                          <span>{item?.account?.email_address || "--"}  | {item?.account?.mobile_number || "--"} </span>
                                        </div>
                                      </div>
                                    </Link>
                                  </DataTableRow>
                                  <DataTableRow>
                                    <span>{item?.profile?.department}</span>
                                  </DataTableRow>
                                  <DataTableRow>
                                    <span>{item?.profile?.position}</span>
                                  </DataTableRow>
                                  <DataTableRow size="mb">
                                    <span className="tb-odr-date">{item?.profile?.inserted_at ? moment(item?.profile?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                  </DataTableRow>
                                  <DataTableRow size="md">
                                    <span className="tb-odr-date">{item?.last_login ? moment(item?.last_login).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                  </DataTableRow>
                                  <DataTableRow size="md">
                                    <span className="tb-odr-status">
                                      <Badge
                                        color={
                                          item?.profile?.status === app_consts.ACTIVE
                                            ? "success"
                                            : "danger"
                                        }
                                        className="badge-dot"
                                      >
                                        {item?.profile?.status?.toUpperCase() || "--"}
                                      </Badge>
                                    </span>
                                  </DataTableRow>
                                  <DataTableRow className="nk-tb-col-tools">
                                    <div className="tb-odr-btns d-none d-sm-inline">
                                      <Link to={`#`}>
                                        <Button color="primary" size="sm" className="btn btn-dim">
                                          View
                                        </Button>
                                      </Link>
                                    </div>
                                    <Button className="btn-pd-auto d-sm-none">
                                      <Icon name="chevron-right"></Icon>
                                    </Button>
                                  </DataTableRow>
                                </DataTableItem>
                              ))
                              : null}
                          </div>
                        </Block>
                      </>
                      :
                      <>
                        <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Employees Found"} />
                      </>
                  }
                  <AdminAddEmployeeToModule isOpen={add_employee_to_module_modal} closeModal={close_add_employee_to_module_modal} successFunction={add_employee_to_module_modal_successFunction} data={data} tenant_info={tenant_info} user_info={user_info} />
                </>
            }
          </>
      }
    </>
  );
};

export default AdminViewTenantPromotionsEmployeesModal;